import DataFieldTableActions from '@/components/data-fields/DataFieldTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import type { DataField } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<DataField>[] = [
    {
        accessorKey: 'data_field_id',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.data_fields.id',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'data_field_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.data_fields.status_text',
            }),
    },
    {
        accessorKey: 'data_field_status_text',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.approved',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'data_field_group_lang',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.data_fields.group',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'data_field_color_lang',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'system.data_fields.color',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(DataFieldTableActions, {
                dataField: row.original,
            });
        },
    },
];
